import { ActivatedRoute } from '@angular/router';
import { BestLenders } from '../shared/best-lenders';
// import { FruHttpService } from './fru-http.service';
import {BehaviorSubject} from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class BestService {
  private clientId: string = '';
  private position: BehaviorSubject<string> = new BehaviorSubject('');
  private fruSource: BehaviorSubject<string> = new BehaviorSubject('');
  private clientIdObj: BehaviorSubject<string> = new BehaviorSubject('');
	private list: string[] = [];

	constructor(private route: ActivatedRoute,
		// private fruHttp: FruHttpService,
		private bestLenders: BestLenders
	) {
		this.getBestLenders();
	}

	get lender(): string {
		return this.clientId;
	}

  get clientPosition(): any {
    return this.position.asObservable();
  }

  get clientFruSource(): any {
    return this.fruSource.asObservable();
  }

  get lenderSubscribe(): any {
    return this.clientIdObj;
  }

	/**
	 * get list best lenders from api call
   */
	private getBestLenders() {
		this.bestLenders.getBestLenders().subscribe(bestList => {
      this.list = bestList;

			this.route.queryParams.subscribe(params => {
				if (typeof params.l !== 'undefined' && params.l !== '' && typeof this.list !== 'undefined' && this.list.includes(params.l)) {
					this.clientIdObj.next(params.l);
          this.clientId = params.l;
          this.position.next(params.position);
          this.fruSource.next(params.fru_source);
				}
			});
		})
	}
}
